"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedMessage = void 0;
const epic_react_common_1 = require("epic-react-common");
Object.defineProperty(exports, "localizedMessage", { enumerable: true, get: function () { return epic_react_common_1.localizedMessage; } });
const LocalizationStore_1 = __importDefault(require("../../stores/LocalizationStore"));
exports.default = epic_react_common_1.registerMessageCommon(LocalizationStore_1.default);
//# sourceMappingURL=Message.js.map